import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import ChartingPreRender from '../../common/ChartingPreRender';
import PreRender from '../../common/PreRender';
import { withSyncDragCode } from '../../common/sync-drag-code';
import { removeDragCode, syncComponentSelector } from '../../helpers/Common';
import TradingView from './trading-view/TradingView';
import './index.scss';

class Charting extends PureComponent {
  constructor(props) {
    super(props);
    removeDragCode(this.props.glContainer);
  }

  render() {
    const { locale, id, glEventHub, glContainer, dragCode } = this.props;
    return (
      <PreRender {...this.props}>
        <div className="p-10 h-100 technical-charting">
          <ChartingPreRender>
            <TradingView
              dragCode={dragCode}
              key={locale}
              glContainer={glContainer}
              glEventHub={glEventHub}
              id={id}
            />
          </ChartingPreRender>
        </div>
      </PreRender>
    );
  }
}

Charting.propTypes = {
  locale: PropTypes.string.isRequired,
  glContainer: PropTypes.object.isRequired,
};

const mapStateToProps = (state, { glContainer, id }) => ({
  locale: state.i18n.locale,
  syncType: syncComponentSelector(
    state,
    glContainer._config.props.componentName,
    id,
  ),
});
export default compose(
  connect(mapStateToProps),
  withSyncDragCode,
)(Charting);
